import styles from './InternetRecommender.module.scss';
import { useLocalStorage, useTracking } from '../../hooks';
import { AddressPicker } from '../../components';
// this needs to be refactored to a separate component
import Error from '../../components/HeatRecommender/Responses/Error/Error.js';
import { STEPS, defaultValues } from './InternetRecommender.config';
import { Available, NotifyInternetRecommender } from './components';
import React, { useState, useEffect } from 'react';
import { Card, FontAwesomeProIcon, Heading } from '@wienenergiegithub/ui-next';
import PropTypes from 'prop-types';

const InternetRecommender = ({
  availableCallback = null,
  bauvorhabenSite,
  configurationUrl,
  onSubmit,
  onUnavailable,
  unavailableCallback,
  unavailableSite,
  variant,
  withNotify,
}) => {
  const [step, setStep] = useState(STEPS.CHECK_AVAILABILITY);
  const [storage, setStorage] = useLocalStorage('address-check', defaultValues);
  const [storageTkconnid, setStorageTkconnid] = useLocalStorage('tkconnid', {});
  const track = useTracking();

  useEffect(() => {
    if (storage && storage.Internet === 'JA') {
      setStep(STEPS.AVAILABLE);
      if (availableCallback) {
        availableCallback();
      }
    }
  }, [storage]);

  const handleOnUnavailable = (...args) => {
    if (unavailableSite) {
      window.open(unavailableSite.url, '_self');
    } else if (
      unavailableCallback &&
      typeof unavailableCallback === 'function'
    ) {
      return unavailableCallback();
    }
    return onUnavailable(...args);
  };

  const handleNewCheck = () => {
    setStorage(defaultValues);
    setStorageTkconnid({});
    setStep(STEPS.CHECK_AVAILABILITY);
  };

  if (
    variant === 'notify' ||
    (step === STEPS.NOTIFY_AVAILABILITY && withNotify)
  ) {
    return (
      <NotifyInternetRecommender
        bauvorhabenSite={bauvorhabenSite}
        onSubmit={onSubmit}
        withReason
      />
    );
  }

  const handleOnSuccess = async (availabilities, postValues, tkconnid) => {
    if (!availabilities) {
      return;
    }

    const internet = availabilities.find(({ sparte }) => sparte === 'Internet');
    const id = availabilities.find(({ ID }) => ID);

    setStorage({
      ...storage,
      ...id,
    });

    if (
      (internet?.verfuegbar === 'JA' ||
        internet?.verfuegbar === 'IM_GEBAEUDE') &&
      tkconnid
    ) {
      track({
        event: 'superschnell_verfuegbar',
        title: 'Superschnell verfuegbar',
        options: {
          zipcode: postValues.plz,
        },
      });

      window.location.hash = 'productSlider';
      if (availableCallback) {
        availableCallback();
      }

      setStep(STEPS.AVAILABLE);
    } else {
      track({
        event: 'superschnell_nicht-verfuegbar',
        title: 'Superschnell nicht verfuegbar',
        options: {
          zipcode: postValues.plz,
        },
      });

      handleOnUnavailable(unavailableSite);
    }
  };

  const handleOnError = error => {
    setStep(STEPS.ERROR);
    if (error?.response) {
      // eslint-disable-next-line no-console
      console.log(error?.response);
    }
  };

  return (
    <Card className={styles.container}>
      <div className={styles.disclosure}>
        <div className={styles.headingGroup}>
          <FontAwesomeProIcon
            className={styles.wifiIcon}
            icon="wifi"
            role="presentation"
            size="2x"
          />
          <Heading as="span" noSpacing size="h6" theme="neutral">
            Ist SuperSchnell bei mir verfügbar?
          </Heading>
        </div>
      </div>
      <div className={styles.content}>
        {step === STEPS.CHECK_AVAILABILITY && (
          <AddressPicker
            buttonId="internet-ueberpruefen"
            onError={handleOnError}
            onSuccess={handleOnSuccess}
            subtitle="Bitte geben Sie hier Ihre Adresse ein:"
            type="internet"
          />
        )}
        {step === STEPS.AVAILABLE && (
          <Available
            configurationUrl={configurationUrl}
            onClick={handleNewCheck}
            withNotify={withNotify}
          />
        )}
        {step === STEPS.ERROR && <Error onNewCheck={handleNewCheck} />}
      </div>
    </Card>
  );
};

InternetRecommender.propTypes = {
  availableCallback: PropTypes.func,
  bauvorhabenSite: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
    target: PropTypes.string,
  }),
  configurationUrl: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
  }),
  onSubmit: PropTypes.func,
  onUnavailable: PropTypes.func,
  unavailableCallback: PropTypes.func,
  unavailableSite: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string,
    target: PropTypes.string,
  }),
  variant: PropTypes.oneOf(['reduced', 'notify', '']),
  withNotify: PropTypes.bool,
};

export { InternetRecommender };
